module.exports = __webpack_public_path__ + "sl-star-5.51337305b00b4a340d93d23e5a4a3bfa.svg";